import { render, staticRenderFns } from "./ParameterHierarchyGuide.vue?vue&type=template&id=3b827374&scoped=true"
import script from "./ParameterHierarchyGuide.vue?vue&type=script&lang=ts"
export * from "./ParameterHierarchyGuide.vue?vue&type=script&lang=ts"
import style0 from "./ParameterHierarchyGuide.vue?vue&type=style&index=0&id=3b827374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b827374",
  null
  
)

export default component.exports